const { cxt } = require('./context');

const {
  payment,
} = require('../schema');

/**
 * Validates the VX Core Sales Split from incoming Sales Data
 * @type {Array<cxt>}
 * @memberof validators
 */
const paymentRequestValidator = [
  cxt('schema', { schema: payment.paymentRequest, opts: { nestedErrors: true } }),
];

/**
 * Validates the VX Core Sales Split from incoming Sales Data
 * @type {Array<cxt>}
 * @memberof validators
 */
const paymentSubmissionValidator = [
  cxt('schema', { schema: payment.paymentSubmission, opts: { nestedErrors: true } }),
];

module.exports = {
  paymentRequest: paymentRequestValidator,
  paymentSubmission: paymentSubmissionValidator,
};
